import React, { useState } from 'react';
import { testimonials } from '../../data/mock';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from '../ui/button';

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-teal-100/30 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-64 h-64 bg-cyan-100/30 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-teal-100 text-teal-700 text-sm font-medium rounded-full mb-6">
            Everyday Stories
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
            Beyond
            <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent"> The Numbers</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            What It Looks Like in Real Life
          </p>
        </div>

        {/* Testimonials carousel */}
        <div className="max-w-4xl mx-auto">
          {/* Main testimonial card */}
          <div className="relative bg-gradient-to-br from-slate-50 to-teal-50/50 rounded-3xl p-8 lg:p-12 border border-slate-100 shadow-xl">
            {/* Quote icon */}
            <div className="absolute top-8 right-8 lg:top-12 lg:right-12">
              <Quote className="w-16 h-16 text-teal-100" />
            </div>

            {/* Stars */}
            <div className="flex gap-1 mb-6">
              {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                <Star key={i} className="w-6 h-6 text-amber-400 fill-amber-400" />
              ))}
            </div>

            {/* Testimonial content */}
            <blockquote className="text-xl lg:text-2xl text-slate-700 leading-relaxed relative z-10">
              "{testimonials[activeIndex].content}"
            </blockquote>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <Button
              variant="outline"
              size="icon"
              onClick={prevTestimonial}
              className="w-12 h-12 rounded-full border-slate-200 hover:border-teal-300 hover:bg-teal-50 transition-all duration-300"
            >
              <ChevronLeft className="w-5 h-5 text-slate-600" />
            </Button>

            {/* Dots indicator */}
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === activeIndex
                      ? 'bg-gradient-to-r from-teal-500 to-cyan-500 w-8'
                      : 'bg-slate-300 hover:bg-slate-400'
                  }`}
                />
              ))}
            </div>

            <Button
              variant="outline"
              size="icon"
              onClick={nextTestimonial}
              className="w-12 h-12 rounded-full border-slate-200 hover:border-teal-300 hover:bg-teal-50 transition-all duration-300"
            >
              <ChevronRight className="w-5 h-5 text-slate-600" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
